<template>
  <div class="calculator__items">
    <div class="calculator__item calculator__item_active">
      <div class="calculator__item-content">
        <div class="calculator__cols calculator__cols_customs">
          <div class="calculator__col calculator__col_desc">
            <div class="calc-pay__title">
              Ваше отправление
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Откуда
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.sender.pointAddress }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Отправитель
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.sender.name }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Куда
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.receiver.pointAddress }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Получатель
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.receiver.name }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Срок доставки
              </div>
              <div class="calc-pay__item__text">
                {{ checkDeliveryMethod.time }}&nbsp;
                {{ num2str(checkDeliveryMethod.time, [' рабочий', ' рабочих', ' рабочих']) }}
                {{ num2str(checkDeliveryMethod.time, [' день', ' дня', ' дней']) }}
              </div>
            </div>
            <div
              v-if="items && items.length"
              class="accordion accordion_calc mt-3"
            >
              <div class="accordion__items calculator-options__items">
                <div
                  class="accordion__item accordion-services"
                  :class="{'accordion__item_active': showDeliveryItems}"
                >
                  <p
                    class="accordion__title"
                    @click="showDeliveryItems = !showDeliveryItems"
                  >
                    <span class="calculator-field__label">Состав посылки</span>
                    <svg
                      class="ms-auto"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </p>
                  <div class="accordion__inner">
                    <ul
                      class="accordion-customs__ul"
                    >
                      <li
                        v-for="item in items"
                        :key="item.descrExp"
                        class="accordion-customs__li"
                      >
                        <svg
                          class="accordion-customs__li__icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.252 4.06815L8.252 0.568148C8.17552 0.523518 8.08855 0.5 8 0.5C7.91145 0.5 7.82448 0.523518 7.748 0.568148L1.748 4.06815C1.67251 4.1122 1.60989 4.17527 1.56637 4.25107C1.52286 4.32687 1.49997 4.41275 1.5 4.50015V11.5001C1.49997 11.5875 1.52286 11.6734 1.56637 11.7492C1.60989 11.825 1.67251 11.8881 1.748 11.9321L7.748 15.4321C7.82448 15.4768 7.91145 15.5003 8 15.5003C8.08855 15.5003 8.17552 15.4768 8.252 15.4321L14.252 11.9321C14.3275 11.8881 14.3901 11.825 14.4336 11.7492C14.4771 11.6734 14.5 11.5875 14.5 11.5001V4.50015C14.5 4.41275 14.4771 4.32687 14.4336 4.25107C14.3901 4.17527 14.3275 4.1122 14.252 4.06815ZM8 1.57915L13.008 4.50015L8 7.42115L2.992 4.50015L8 1.57915ZM2.5 5.37015L7.5 8.28665V14.1301L2.5 11.2131V5.37015ZM8.5 14.1301V8.28715L13.5 5.37065V11.2131L8.5 14.1301Z"
                            fill="#50616F"
                          />
                        </svg>
                        <div class="d-flex flex-column">
                          <span
                            v-if="item.descrExp"
                            class="accordion-customs__li__title"
                          >
                            {{ item.descrExp }}
                          </span>
                          <span class="accordion-customs__li__text">
                            {{ item.quantity }}шт, стоимость {{ item.priceExport }} €
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="orderPIP.sender.country === COUNTRY_CODES.RUSSIA"
              class="accordion accordion_calc"
            >
              <div class="accordion__items calculator-options__items">
                <CalculatorServicesOptions
                  v-if="!hideServices && checkDeliveryMethod && checkDeliveryMethod.services"
                  :delivery-services-list="checkDeliveryMethod.services"
                />
              </div>
            </div>

            <Recaptcha
              v-if="isMobile"
              ref="recaptcha"
              :public-key="recaptchaKey"
              @verified="dataRecaptcha"
              @expired="removeDataRecaptcha"
            />
          </div>
          <div
            v-if="!isMobile"
            class="calculator__col calculator__col_total"
          >
            <CalcTotal
              class="calc-pay__total"
              :calc-import="calcImport"
              :order-p-i-p="orderPIP"
              :order-calc-p-i-p="orderCalcPIP"
              :promocode-submitted="promocodeSubmitted"
              :check-delivery-method="checkDeliveryMethod"
              :total-price="totalPrice"
              :total-price-import="totalPriceImport"
              :is-valid="true"
              :is-loading="isLoading"
              :cbr-daily="cbrDaily"
              :is-direction-kz-kz="isDirectionKzKz"
            >
              <template #btn>
                <div class="mt-3 calculator-total__recaptcha-wrap">
                  <Recaptcha
                    ref="recaptcha"
                    :public-key="recaptchaKey"
                    @verified="dataRecaptcha"
                    @expired="removeDataRecaptcha"
                  />
                </div>
                <a
                  class="calculator__button calculator__button_red"
                  :class="{ 'calculator__button_loading': isLoading }"
                  @click.prevent="onBtnCreateClick"
                >
                  Создать электронную накладную
                </a>
              </template>
            </CalcTotal>
          </div>
        </div>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      :is-loading="isLoading"
      :error-text="navErrorText"
      :hide-btn-next="true"
      @step-back="$emit('step-back')"
    />
    <CalcNavMobile
      v-else
      :is-loading="isLoading"
      :error-text="navErrorText"
      @step-back="$emit('step-back')"
      @stepValidation="onBtnCreateClick"
    >
      <template #btnNext>
        Оформить ЭН
      </template>
    </CalcNavMobile>
  </div>
</template>


<script>
import CalcNavDesktop from '../components/CalcNavDesktop.vue';
import CalcNavMobile from '../components/CalcNavMobile.vue';
import deviceInfo from '../../../helpers/device';
import CalcTotal from '../components/CalcTotal.vue';
import Recaptcha from '../../ComponentsForm/Recaptcha.vue';
import { submitOrder } from '../../../models/calculator-pip';
import CalculatorServicesOptions from '../CalculatorServicesOptions.vue';

import num2str from '../../../helpers/num2str';
import { COUNTRY_CODES } from '../../../helpers/constans';

export default {
  name: 'CalculatorPIPPayCustomsView',
  components: {
    CalcTotal,
    CalcNavMobile,
    CalcNavDesktop,
    CalculatorServicesOptions,
    Recaptcha,
  },
  props: {
    checkDeliveryMethod: {
      type: Object,
      default: () => ({}),
    },
    orderPIP: {
      type: Object,
      required: true,
    },
    orderCalcPIP: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    totalPrice: {
      type: String,
      required: true,
    },
    totalPriceImport: {
      type: String,
      required: true,
    },
    cbrDaily: {
      type: Array,
      default: () => ([]),
    },
    orderNum: {
      type: String,
      required: true,
    },
    errorDictionary: {
      type: Object,
      required: true,
    },
    paymentId: {
      type: String,
      required: true,
    },
    absoluteUrl: {
      type: String,
      default: '',
    },
    hideServices: {
      type: Boolean,
      default: false,
    },
    calcImport: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    promocodeSubmitted: {
      type: Boolean,
      default: false,
    },
    isDirectionKzKz: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    recaptchaKey: window.recaptchaKey || null,
    dataCaptcha: null,
    num2str,
    isLoadingRussian: false,
    isDisabledRussian: false,
    isLoadingOther: false,
    isDisabledOther: false,
    showDeliveryItems: false,
    isLoading: false,
  }),
  computed: {
    ...deviceInfo,
    navErrorText() {
      return '';
    },
  },
  created() {
    this.COUNTRY_CODES = COUNTRY_CODES;
  },
  methods: {
    dataRecaptcha(value) {
      this.dataCaptcha = value;
      this.orderPIP.dataCaptcha = this.dataCaptcha;
    },
    removeDataRecaptcha() {
      this.dataCaptcha = null;
      this.orderPIP.dataCaptcha = null;
    },
    onBtnCreateClick() {
      if (!this.dataCaptcha) return;
      this.isLoading = true;

      submitOrder(this.orderPIP, this.errorDictionary, this.orderCalcPIP, this.salePip, this.items, true, this.totalPrice)
        .then((orderNumber) => {
          this.$emit('step-up', orderNumber);
        })
        .catch((errArr) => {
          this.$emit('error', errArr.message);
          this.$refs.recaptcha.reset();
        })
        .finally(() => {
          this.isLoading = false;
          // this.resetConfirmReceiverDetailsOtherCountry();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.accordion-customs__ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.accordion-customs__li {
  position: relative;
  padding: 4px 0 4px 24px;
  border-bottom: 1px solid rgba(159, 179, 195, 0.3);
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
}
.accordion-customs__li__icon {
  position: absolute;
  top: 4px;
  left: 0;
}

.calculator-options__info__left {
  max-width: 57%;
  @media (max-width: 767px) {
    margin-top: 20px;
    max-width: 100%;
  }
}
.calculator-total__btn {
  margin-top: 40px;
  padding: 12px 20px;
  width: 100%;
  min-height: 46px;
  justify-content: center;
}
.calculator-total__recaptcha-wrap {
  margin-bottom: 24px;
  min-height: 78px;
  @media (max-width: 330px) {
    max-width: 280px;
    overflow: hidden;
  }
}
.calculator__col_desc {
  flex-basis: 640px;
}
.calculator__col_total {
  flex-basis: 440px;
}
.accordion-services {
  @media (min-width: 768px) {
    width: calc(100% - 12px);
    margin-left: 6px;
  }
}
.accordion-customs__li__title {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 700;
  line-height: 17px;
  color: #50616F;
}
.accordion-customs__li__text {
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  color: #50616F;
}
.calculator__cols_customs {
  align-items: flex-start;
}
</style>
